import { render, staticRenderFns } from "./Pacific.vue?vue&type=template&id=5c9b1a84&"
import script from "./Pacific.vue?vue&type=script&lang=js&"
export * from "./Pacific.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports